import { Injectable } from '@angular/core';
import { AbstractSecurityStorage } from 'angular-auth-oidc-client';

@Injectable()
//OidcPrefixedStorageService is a custom storage service that prefixes keys with 'oidc_' to avoid conflicts with other localStorage items.
export class OidcPrefixedStorageService extends AbstractSecurityStorage {
  private prefix = 'oidc_';

  read(key: string): any {
    const value = localStorage.getItem(this.prefix + key);
    if (!value) return null;
    try {
      return JSON.parse(value);
    } catch {
      return value;
    }
  }

  write(key: string, value: any): void {
    if (value === null || value === undefined) {
      this.remove(key);
      return;
    }
    localStorage.setItem(this.prefix + key, JSON.stringify(value));
  }

  remove(key: string): void {
    localStorage.removeItem(this.prefix + key);
  }

  clear(): void {
    Object.keys(localStorage)
      .filter(key => key.startsWith(this.prefix))
      .forEach(key => localStorage.removeItem(key));
  }

}
